export interface Patient {
  id: number;
  fullname: string;
  birthday: Date | string;
  phoneNumber: string;
  dni: string | number;
  address: string;
  email: string;
  gender: string;
  insurance: string;
  prepaid?: string | number;
  memberNumber: string | number;
  tutor_name?:string;
  age?:number;
  date_birth?:string;
  pathologies?: Pathology[];
  doctors?: Doctors[];
  clientFullname?: string;
  asociated_medics?: Doctors[];
}

export interface Doctors {
  fullname: string;
  medic_id: number;
}

export interface Pathology {
  id: number;
  name: string;
  description?: string;
}

export interface SimplePatientList {
  patient_id: number;
  fullname: string;
  age?: number;
  date_birth?:  string;
}
export interface patientID {
  patient_id: number;
}